import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';

import './FloatingMenu.css';
import Icon from '../Icon/Icon';

const FloatingMenu = ({ menuItems }) => {
  return (
    <div styleName="container">
      {menuItems.map(({ label, icon, isDisabled, onClick, children }) => {
        return (
          <div styleName="item" key={label}>
            <button
              type="button"
              styleName="button"
              onClick={onClick}
              disabled={isDisabled}
              name={label}
            >
              {icon && (
                <span styleName="icon">
                  <Icon fixedWidth icon={icon} size="lg" />
                </span>
              )}
              <span styleName="text">{i18next.t(label, label)}</span>
              {children}
            </button>
          </div>
        );
      })}
    </div>
  );
};

FloatingMenu.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
      ]),
      onClick: PropTypes.func.isRequired
    })
  ).isRequired
};

export default FloatingMenu;
